import { M8PaymentTransactionDTO } from 'services/production/types';
import { normalizeM8UserProfile } from 'services/production/utils/normalizeM8UserProfile';
import { CardPayment, TransactionPayment } from 'types/state';
import { normalizeM8PaymentTransactionStatus } from 'services/production/utils/normalizeM8PaymentTransactionStatus';

export const normalizeM8PaymentTransactionDTO = (
  transaction: M8PaymentTransactionDTO
) => ({
  toCardPayment(): CardPayment {
    return {
      id: transaction.id,
      description: transaction.description,
      creditedTransaction:
        transaction.billedCurrency !== null && transaction.billedAmount !== null
          ? {
              currency: transaction.billedCurrency,
              amount: transaction.billedAmount,
            }
          : null,
      recievedTransaction: {
        currency: transaction.amountCurrency,
        amount: transaction.amount,
      },
      exchangeRate: transaction.exchangeRate,
      createdAt: transaction.createdOn,
      updatedAt: transaction.updatedOn,
      orderId: transaction.orderNumber,
      userId: transaction.user.id,
      userProfile: normalizeM8UserProfile(transaction.user).toUserProfileInfo(),
      status: normalizeM8PaymentTransactionStatus(
        transaction.status
      ).toCardPaymentStatus(),
    };
  },
  toTransactionPayment(): TransactionPayment {
    return {
      type: 'PAYMENT',
      payment: normalizeM8PaymentTransactionDTO(transaction).toCardPayment(),
    };
  },
});
